import { Image } from '@chakra-ui/react';
import React from 'react';

import needHelpIcon from '../../../../../../assets/icons/icon_need_help.svg';
import { useSelectorNeedHelp } from '../../../../../configuration';
import { NeedHelpContainer } from './need-help-button.styled';

export const NeedHelpButton = () => {
    const needHelpUrl = useSelectorNeedHelp();

    return (
        <NeedHelpContainer
            data-testid={'need-help'}
            onClick={() => { window.open(needHelpUrl, '_blank'); }}
        >
            <Image src={needHelpIcon} w={'24px'} />
        </NeedHelpContainer>
    );
};
